export default __webpack_public_path__ + "images/models/e5a0afccbf7a4d3a7c52adf3d75c549c.glb";